module.exports = __webpack_public_path__ + "static/media/itc-2021-Comprehensive-Booklet.cb98c32b.png";